import ListingContainer from "components/UI/organisms/ListingContainer";
import React from "react";
import ApplicationCard from "../components/ApplicationCard";
import { Grid } from "@mui/material";
import { useLocalizedTranslation } from "helpers/hooks/useLocalizedTranslation";

const ApplicationsLiting = ({
  loading,
  applications,
  pageCount,
  page,
  setPage,
  noPagination,
  emptyView,
  gridType = 1,
  handleUpdateApplicationStatus,
}) => {
  const { t } = useLocalizedTranslation("common");
  return (
    <ListingContainer
      loading={loading}
      isEmpty={!applications?.length}
      count={pageCount}
      page={page}
      setPage={setPage}
      classes="mt-2"
      emptyText={t("No applications found!")}
      noPagination={noPagination}
      emptyView={emptyView}
      small
      rowSpacing={gridType === 2 && 1}
    >
      {applications.map((d) => (
        <Grid item key={d?.id} xs={12} sm={6} lg={gridType === 1 ? 12 : 4}>
          <ApplicationCard
            data={d}
            col={gridType === 2}
            handleUpdateApplicationStatus={handleUpdateApplicationStatus}
            t={t}
          />
        </Grid>
      ))}
    </ListingContainer>
  );
};

export default ApplicationsLiting;
